"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositionType = void 0;
var CompositionType;
(function (CompositionType) {
    CompositionType["Roof"] = "Roof";
    CompositionType["InteriorWall"] = "Interior Wall";
    CompositionType["ExteriorWall"] = "Exterior Wall";
    CompositionType["Floor"] = "Floor";
    CompositionType["Kitchen"] = "Kitchen";
    CompositionType["Staircase"] = "Staircase";
    CompositionType["Fireplace"] = "Fireplace";
})(CompositionType = exports.CompositionType || (exports.CompositionType = {}));
